import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { useCreditUsageSourcesContext } from 'pages/analytics/pages/creditUsage/pages/sources/context/creditUsageSourcesContext'
import { getColumns } from './getColumns'
import styles from './styles.module.scss'

export const SourcesTable = observer(() => {
  const {
    sourcesTableStore: { tableStore, rows, setSearch },
  } = useCreditUsageSourcesContext()

  const columns = useMemo(() => getColumns(), [])

  return (
    <div className={styles.wrap}>
      <div className={styles.searchWrap}>
        <TableSearch value={tableStore.search} onChange={setSearch} className={styles.search} />
      </div>
      <Table
        ariaLabel={'SourcesTable'}
        store={tableStore}
        columns={columns}
        rows={rows}
        sxTable={{ tableLayout: 'fixed' }}
      />
    </div>
  )
})
